<template>
  <div v-bind:class="[base, filterJustify(justify), filterAlign(align), filterDirection(direction)]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      base: 'rf-flex'
    }
  },
  props: {
    justify: {
      default: 'rf-flex',
      type: String
    },
    align: {
      default: '',
      type: String
    },
    direction: {
      default: '',
      type: String
    }
  },
  methods: {
    filterDirection (type) {
      switch (type) {
        case 'row': return 'direction-row'
        case 'row-reverse': return 'direction-row-reverse'
        case 'column': return 'direction-column'
        case 'column-reverse': return 'direction-column-reverse'
        default: return ''
      }
    },
    filterJustify (type) {
      switch (type) {
        case 'start': return 'flex-start'
        case 'end': return 'flex-end'
        case 'center': return 'flex-center'
        case 'between': return 'flex-between'
        case 'around': return 'flex-around'
        default: return ''
      }
    },
    filterAlign (type) {
      switch (type) {
        case 'start': return 'align-start'
        case 'end': return 'align-end'
        case 'center': return 'align-center'
        case 'baseline': return 'align-baseline'
        default: return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.rf-flex {
  pointer-events: auto;
  display: flex;
}
.flex-start {
  justify-content: flex-start;
}
.flex-end {
  justify-content: flex-end;
}
.flex-center {
  justify-content: center;
}
.flex-between {
  justify-content: space-between;
}
.flex-around {
  justify-content: space-around;
}
.align-start {
  align-items: flex-start;
}
.align-end {
  align-items: flex-end;
}
.align-center {
  align-items: center;
}
.align-baseline {
  align-items: baseline;
}
.direction-row {
  flex-direction: row;
}
.direction-row-reverse {
  flex-direction: row-reverse;
}
.direction-column {
  flex-direction: column;
}
.direction-column-reverse {
  flex-direction: column-reverse;
}
</style>
